/* Mixed exercise components. The shared scripts handle MC, recording, tabs and leads. */
(function (root) {
  'use strict';
  var NUM = { zero:'0', one:'1', wun:'1', two:'2', too:'2', three:'3', tree:'3', four:'4', fower:'4', five:'5', fife:'5', six:'6', seven:'7', eight:'8', ait:'8', nine:'9', niner:'9' };
  var DOT = { decimal:1, point:1, dayseemal:1 };
  // Follow the readback checker's ICAO digit and decimal conventions.
  function normalize(text) {
    var s = String(text || '').toLowerCase().trim()
      .replace(/(\d),(\d{3})/g, '$1$2').replace(/(\d)\s*\.\s*(\d)/g, '$1.$2')
      .replace(/flight\s*level/g, ' fl ').replace(/tousand/g, 'thousand')
      .replace(/[,;:\/]/g, ' | ').replace(/[^a-z0-9.|\s]/g, ' ')
      .replace(/\.(?!\d)/g, ' ').replace(/(^|[^\d])\./g, '$1 ')
      .replace(/([a-z])(\d)/g, '$1 $2').replace(/(\d)([a-z])/g, '$1 $2');
    var raw = s.split(/\s+/).filter(Boolean).map(function (t) { return NUM[t] || (DOT[t] ? '.' : t); });
    var out = [], i = 0;
    while (i < raw.length) {
      if (/^[\d.]+$/.test(raw[i]) && raw[i] !== '.') {
        var run = raw[i++];
        if (/^\d$/.test(run)) while (i < raw.length && (/^\d$/.test(raw[i]) || raw[i] === '.')) run += raw[i++];
        run = run.replace(/\.+$/, '');
        if (raw[i] === 'thousand' && /^\d+$/.test(run)) {
          var n = +run * 1000; i++;
          if (i + 1 < raw.length && /^\d+$/.test(raw[i]) && raw[i+1] === 'hundred') { n += +raw[i] * 100; i += 2; }
          run = String(n);
        } else if (raw[i] === 'hundred' && /^\d+$/.test(run)) { run = String(+run * 100); i++; }
        out.push(run);
      } else { if (raw[i] !== '.' && raw[i] !== '|') out.push(raw[i]); i++; }
    }
    return out.join(' ');
  }
  function matches(input, accept, keys) {
    var value = normalize(input);
    if (!value) return false;
    if (accept.some(function (a) { return normalize(a) === value; })) return true;
    return keys.length > 0 && keys.every(function (k) {
      var key = normalize(k);
      return key && (' ' + value + ' ').indexOf(' ' + key + ' ') !== -1;
    });
  }
  var api = { normalize: normalize, matches: matches };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (typeof document === 'undefined') return;
  var main = document.querySelector('[data-ex="kit"]');
  if (!main) return;
  function all(selector, element) { return Array.prototype.slice.call((element || main).querySelectorAll(selector)); }
  var units = all('[data-kit-unit]'), progress = main.querySelector('[data-ex-progress]'), bar = main.querySelector('[data-ex-bar]');
  function done(el) {
    var kind = el.getAttribute('data-kit-unit');
    return kind === 'question' || kind === 'type' ? el.classList.contains('is-correct') || el.classList.contains('is-wrong') : el.classList.contains('is-revealed');
  }
  function update() {
    var count = units.filter(done).length;
    if (progress) progress.textContent = count + ' of ' + units.length + ' done';
    if (bar) bar.style.width = (units.length ? count / units.length * 100 : 0) + '%';
  }
  all('form[data-drill-form]').forEach(function (form) {
    var check = form.querySelector('[data-kit-mc-check]'); if (check) check.hidden = false;
    // The drills script has already checked the answers by the time this listener runs.
    form.addEventListener('submit', update);
    all('fieldset.practice-q', form).forEach(function (question) {
      question.addEventListener('change', function () {
        question.classList.remove('is-correct', 'is-wrong');
        all('.practice-option', question).forEach(function (option) { option.classList.remove('is-answer'); });
        var why = question.querySelector('.practice-why'); if (why) why.hidden = true;
        var status = form.querySelector('.practice-status'); if (status) status.textContent = '';
        update();
      });
    });
  });
  all('[data-kit-type]').forEach(function (form) {
    var input = form.querySelector('input'), status = form.querySelector('[data-kit-status]');
    var solution = form.querySelector('[data-kit-solution]'), button = form.querySelector('[data-kit-check]');
    var accept = JSON.parse(form.getAttribute('data-accept')), keys = JSON.parse(form.getAttribute('data-keys'));
    button.hidden = false;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!input.value.trim()) { status.textContent = 'Type an answer first.'; input.focus(); return; }
      var ok = matches(input.value, accept, keys);
      form.classList.toggle('is-correct', ok); form.classList.toggle('is-wrong', !ok);
      status.textContent = ok ? 'Correct. Compare your answer with the model below.' : 'Not quite. Compare your answer with the model below.';
      solution.open = true;
      update();
    });
    input.addEventListener('input', function () {
      if (form.classList.contains('is-correct') || form.classList.contains('is-wrong')) {
        form.classList.remove('is-correct', 'is-wrong'); status.textContent = ''; update();
      }
    });
  });
  all('[data-kit-card]').forEach(function (button) {
    var answer = document.getElementById(button.getAttribute('aria-controls'));
    if (!answer) return;
    answer.hidden = true; button.hidden = false; button.setAttribute('aria-expanded', 'false'); button.textContent = 'Show answer';
    button.addEventListener('click', function () {
      var show = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', show ? 'true' : 'false');
      button.textContent = show ? 'Hide answer' : 'Show answer'; answer.hidden = !show;
      if (show) button.closest('[data-kit-unit]').classList.add('is-revealed');
      update();
    });
  });
  all('[data-ex-reveal]').forEach(function (button) { button.addEventListener('click', update); });
  all('[data-ex-finish]').forEach(function (button) {
    button.hidden = false;
    button.addEventListener('click', function () {
      var body = main.querySelector('[data-ex-result-body]'); if (!body) return;
      var checked = units.filter(function (el) { return (el.getAttribute('data-kit-unit') === 'question' || el.getAttribute('data-kit-unit') === 'type') && done(el); });
      var correct = checked.filter(function (el) { return el.classList.contains('is-correct'); }).length;
      var count = units.filter(done).length;
      body.textContent = '';
      var summary = document.createElement('p'); summary.className = 'ex-result-lede';
      summary.textContent = 'You completed ' + count + ' of ' + units.length + ' practice items. ' +
        (checked.length ? correct + ' of ' + checked.length + ' checked answers were correct. ' : 'Check some answers to see your result. ') +
        'Review the explanations and compare any speaking answers with the models.';
      body.appendChild(summary); body.setAttribute('aria-live', 'polite');
    });
  });
  update();
})(this);
